module.exports = __webpack_public_path__ + "static/img/换绑.e961dc2.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/换绑.png
// module id = FA6m
// module chunks = 0